import IconArrowDownRed from "components/EvtKit/icons/IconArrowDownRed"
import IconArrowRightGray from "components/EvtKit/icons/IconArrowRightGray"
import IconArrowUpGreen from "components/EvtKit/icons/IconArrowUpGreen"
import Caption from "components/Typography/Caption"
import { memo, useMemo } from "react"
import styled from "styled-components"
import { formatPercentage } from "utils/formatPercentage"
import { formatPrice } from "utils/formatPrice"

const VariationContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`

interface VariationDisplayProps {
  value: App.MetricsSummary
  isPrice?: boolean
}

const VariationDisplay = (props: VariationDisplayProps) => {
  const { isPrice, value } = props

  const { variation, difference } = value

  const { text, Icon: ArrowIcon } = useMemo(() => {
    // When variation is zero but there is a positive absolute difference,
    // show the difference count and the "up" green arrow to indicate growth
    if (variation === 0 && difference > 0) {
      return {
        text: `+${isPrice ? formatPrice(difference, "BRL") : difference} último período`,
        Icon: IconArrowUpGreen
      }
    }

    // When variation is exactly zero with no difference,
    // display "0%" and the neutral arrow
    if (variation === 0) {
      return {
        text: `0% último período`,
        Icon: IconArrowRightGray
      }
    }

    // For non-zero variation, determine increase vs. decrease,
    // add a "+" sign for positive changes, and pick the correct arrow
    const hasIncreased = variation > 0

    const formattedText = (hasIncreased ? "+" : "") + formatPercentage(variation) + " último período"

    const ChosenIcon = hasIncreased ? IconArrowUpGreen : IconArrowDownRed

    return {
      text: formattedText,
      Icon: ChosenIcon
    }
  }, [variation, difference])

  return (
    <VariationContainer>
      <ArrowIcon />
      <Caption color="secondary-medium" size="large" weight="semi-bold">
        {text}
      </Caption>
    </VariationContainer>
  )
}

export default memo(VariationDisplay)
